<div
  class="signup-wrapper"
  [class.mobile]="isMobile()"
  [class.tablet]="isTablet()"
>
  <div class="signup-image">
    @if (isDesktop()) {
      <img
        nz-image
        nzDisablePreview
        nzSrc="assets/images/login_image.jpg"
        alt="login"
        height="100%"
      />
    } @else {
      <img
        nz-image
        nzDisablePreview
        nzSrc="assets/images/login_image_mobile.jpg"
        alt="login-mobile"
        width="100%"
      />
    }
  </div>
  <div class="signupForm">
    @if (isLoading()) {
      <div class="spinner-container">
        <app-spinner [black]="true"></app-spinner>
      </div>
    } @else {
      <div class="innersignup">
        <div class="header-signup">
          <img
            nz-image
            class="logo"
            alt="logo"
            nzDisablePreview
            nzSrc="assets/images/LoctitePulseLogo_red.svg"
          />
          <h1>{{ i18n.langString("approve_user") }}</h1>
          <p>{{ i18n.langString("approve_user_info") }}</p>
        </div>
        <app-common-form
          (formSubmit)="approve($event)"
          (formDenied)="deny($event)"
          [formConfigureInput]="adminAccessFormConfig"
          [submitText]="'Submit Form'"
          [isAdmin]="true"
          [countryList]="countryArray()"
          [customerList]="customerList"
        >
        </app-common-form>
      </div>
    }
  </div>
</div>
